<template>
  <ListCard v-bind="listCardAttrs">
    <template v-if="ques.chip" v-slot:titleChips>
      <ContentChip
        :yellow="ques.chip.color === 'yellow'"
        :light-gray="ques.chip.color === 'gray'"
        :orange="ques.chip.color === 'orange'"
        :text-label="$t(ques.chip.text)"
        :color="ques.chip.color"
      />
    </template>
    <template v-if="variant === 'reset'">
      <ListCardItem row isTable type="text" title="作答" :textContent="ques.answerResult" />
      <ListCardItem row isTable type="slot" title="風險">
        <template v-slot:slot>
          <LvFlexBox>
            <LvIcon size="1.125rem" :icon="ques.answerRisk.icon" :color="ques.answerRisk.color" />
            <LvText h4 textAlign="start" class="ml-4">
              {{ $t(ques.answerRisk.text) }}
            </LvText>
          </LvFlexBox>
        </template>
      </ListCardItem>
      <ListCardItem row isTable type="text" title="標題" :textContent="ques.title" />
    </template>
    <ListCardItem
      v-if="ques.keypoint"
      row
      is-table
      type="condition-chip"
      :color="ques.keypoint.color"
      :textContent="ques.keypoint.textContent"
    />
    <ListCardItem
      row
      isTable
      type="text"
      title="列入結果統計、不合規排行榜、今日點檢結論"
      :textContent="ques.isInStatsText"
    />
    <ListCardItem
      v-if="ques.quesType"
      row
      isTable
      type="text"
      title="題型"
      :textContent="ques.quesType.name"
    />
    <ListCardItem
      v-if="ques.quesType && ques.quesType.value === 'single-choice'"
      row
      isTable
      type="slot"
      title="選項設定"
    >
      <template v-slot:slot>
        <LvInfoQuesOptionList :list="ques.optionList" />
      </template>
    </ListCardItem>
    <ListCardItem
      v-if="ques.quesType && ques.quesType.value === 'num'"
      row
      isTable
      type="text"
      title="條件設定方式"
      :textContent="ques.numConditionType.name"
    />
    <ListCardItem
      v-if="
        ques.quesType &&
        ques.quesType.value === 'num' &&
        ques.numConditionType &&
        ques.numConditionType.type !== 'num-only'
      "
      row
      isTable
      type="slot"
      title="條件設定"
    >
      <template v-slot:slot>
        <LvInfoQuesConditionList
          v-if="ques.numConditionType.type === 'custom-num'"
          :list="ques.conditionList"
        />
        <div v-else-if="ques.numConditionType.type === 'control-limit'">
          <LvText v-if="ques.controlLimitData">{{
            `${$t('Control Limit (管制界線)')}： ${ques.controlLimitData}`
          }}</LvText>
          <LvText v-if="ques.specLimitData">{{
            `${$t('Spec Limit (合規界線)')}： ${ques.specLimitData}`
          }}</LvText>
        </div>
      </template>
    </ListCardItem>
    <ListCardItem
      v-if="ques.unit"
      row
      isTable
      type="text"
      title="單位"
      :textContent="ques.unit"
    />
    <ListCardItem
      row
      is-table
      type="text"
      titleIcon="icon-light"
      :title="$t('合規標準')"
      :textContent="ques.remark"
      :attaches="ques.allAttaches"
    />
    <ListCardItem
      row
      is-table
      type="text"
      titleIcon="icon-help-outline"
      :title="$t('OCAP')"
      :textContent="ques.ocapRemark"
      :attaches="ques.ocapAttaches"
    />
    <ListCardItem
      row
      is-table
      type="links"
      titleIcon="icon-nav-law-outline"
      :title="$t('法規依據')"
      :links="ques.lawLinks"
      :textIconList="ques.effects"
      @click-law="$emit('click-law', $event)"
    />
    <ListCardItem
      row
      isTable
      type="links"
      title="相關內規"
      titleIcon="icon-ll-nav-internalegulations-outline"
      :links="ques.guidelineList"
      @click-law="$emit('click-related-guideline', $event)"
    />
  </ListCard>
</template>

<script>
export default {
  props: {
    ques: {
      type: Object,
      required: true,
    },
    variant: {
      type: String,
      required: true,
      validator: v => v === 'read' || v === 'reset',
    },
  },
  computed: {
    listCardAttrs() {
      if (this.variant === 'read') {
        return {
          isTable: true,
          white: true,
          noPadding: true,
          bigTitle: true,
          title: this.ques.title,
        };
      }
      return {
        isTable: true,
        white: true,
        bigTitle: true,
        noPadding: true,
      };
    },
  },
};
</script>
